import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import "../styles/App.css";

const Event = (event) => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  const eventData = event.event;

  return (
    <div className="event-card">
      <img
        className="event-image"
        src={`data:image/jpg;base64,${eventData.image}`}
        alt={eventData.name}
        width="300px"
        loading="lazy"
      />
    </div>
  );
};
export default Event;
